export default __webpack_public_path__ + "static/media/paid.bac2df14.svg";